import type { AreaPiloto } from "@/types/territorial";

interface PilotHeaderProps {
  area: AreaPiloto;
  quadrasMapeadas: number;
}

export default function PilotHeader({ area, quadrasMapeadas }: PilotHeaderProps) {
  const local = [area.municipalityName, area.uf].filter(Boolean).join("/");
  const quadrasLabel =
    area.expectedBlockCount != null
      ? `${quadrasMapeadas} de ${area.expectedBlockCount} quadras mapeadas`
      : `${quadrasMapeadas} quadras mapeadas`;
  const badges = [
    ...(local ? [{ label: local, icon: "ri-map-pin-line", color: "bg-primary-100 text-primary-700 border-primary-200" }] : []),
    { label: quadrasLabel, icon: "ri-grid-line", color: "bg-accent-100 text-accent-700 border-accent-200" },
    { label: "Área Piloto", icon: "ri-flask-line", color: "bg-secondary-100 text-secondary-700 border-secondary-200" },
  ];

  return (
    <div className="bg-white border-b border-background-200/70 px-5 py-4 shrink-0">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center shrink-0">
              <i className="ri-plant-line text-white text-sm"></i>
            </div>
            <h1 className="text-lg font-bold text-foreground-900 font-heading truncate">
              FloraIQ — {area.neighborhood || area.name}
            </h1>
            {area.status && (
              <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 border border-primary-200 whitespace-nowrap">
                {area.status}
              </span>
            )}
          </div>
          <p className="text-xs text-foreground-500 max-w-2xl">
            {area.name} ({area.code}) — inventário arbóreo urbano e inteligência territorial da arborização
          </p>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {badges.map((b) => (
            <span
              key={b.label}
              className={`inline-flex items-center gap-1 text-[10px] font-medium px-2 py-1 rounded-full border whitespace-nowrap ${b.color}`}
            >
              <i className={`${b.icon} text-[10px]`}></i>
              {b.label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
